import React, { useState } from 'react'
import styled from 'styled-components'
import { Modal, ConfirmButton, Amount, Symbol, CurrencySymbolImage, TokenAmountReceive } from '../../../../common'
import { Colors, INTEGRAL_SYMBOL } from '../../../../constants'
import { useEthers, useSendTransaction } from '../../../../hooks'
import { getStakingWithdrawTransaction } from '../../../../transactions'
import { usePositions } from '../usePositions'
import { getStakingParams, StakingOption } from '../utils'

interface Props {
  stakingOption: StakingOption
  onClose: () => void
  onSubmit: () => void
}

export function ConfirmWithdraw({ stakingOption, onClose, onSubmit }: Props) {
  const { account, chainId } = useEthers()
  const { withdrawable } = usePositions(stakingOption)
  const sendTransaction = useSendTransaction()
  const [sending, setSending] = useState(false)

  async function withdrawStake() {
    if (!account || !chainId || !withdrawable) {
      return
    }
    setSending(true)
    try {
      await sendTransaction(getStakingWithdrawTransaction(chainId, account, stakingOption, withdrawable))
      onSubmit()
      setSending(false)
    } catch (err) {
      setSending(false)
      if (err instanceof Error) {
        alert(err.message) // TODO: better error handling
      }
    }
  }

  const canWithdraw = withdrawable?.value.gt(0)
  const { duration } = getStakingParams(stakingOption)
  return (
    <Modal title="Confirm Withdraw" onClose={onClose}>
      <Content>
        <Label>{`${duration} Staking`}</Label>
        <TokenAmountReceive>
          <Amount>{withdrawable ? withdrawable.format() : '-'}</Amount>
          <Symbol>
            <CurrencySymbolImageStyled symbol={INTEGRAL_SYMBOL} />
            {INTEGRAL_SYMBOL}
          </Symbol>
        </TokenAmountReceive>
        <ConfirmButtonStyled
          onClick={withdrawStake}
          disabled={!account || !canWithdraw}
          sending={sending}
          text={account ? 'Withdraw' : 'Connect wallet'}
        />
      </Content>
    </Modal>
  )
}

const Content = styled.div`
  padding: 15px 20px;
  color: ${Colors.Black};
`

const Label = styled.strong`
  margin-bottom: 8px;
  display: block;
  font-size: 11px;
  text-align: left;
  text-transform: uppercase;
`

const CurrencySymbolImageStyled = styled(CurrencySymbolImage)`
  margin-right: 5px;
`

const ConfirmButtonStyled = styled(ConfirmButton)`
  margin-top: 20px;
`
